






































































































































import { ClientAccount } from '@/shared/clients/client-account';
import { ClientRelationshipType } from '@/shared/types/client-relationship-type';
import { Validator } from 'vee-validate';
import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const typesModule = namespace('types');
const userModule = namespace('user');

@Component
export default class ClientAdditionalDetails extends Vue {
    @typesModule.Getter('activeClientRelationshipTypes') private relationshipTypes!: Array<ClientRelationshipType>;
    @userModule.Getter('isInternalKeyStakeholder') private isInternalKeyStakeholder!: boolean;

    @Inject('$validator') public $validator!: Validator;
    @Prop({ required: true }) private client!: ClientAccount;

    private foo: boolean | null = null;

    private get showMatterDetails(): boolean {
        return this.client.matterId != null
            || this.client.matterReceived != null
            || this.client.matterOpened != null
            || this.client.matterClosed != null
            || this.client.matterDescription != null;
    }

    @Watch('client.hasChildren')
    private onHasChildrenChanged(value: boolean | null) {
        if (value === null) {
            this.client.hasChildrenUnderEighteen = null;
            return;
        }
        if (value === false) {
            this.client.hasChildrenUnderEighteen = false;
            return;
        }
    }

    @Watch('client.hasChildrenUnderEighteen')
    private onHasChildrenUnderEighteenChanged(value: boolean | null) {
        if (value === true) {
            this.client.hasChildren = true;
        }
    }

    private onNationalInsuranceNumberChanged(nationalInsuranceNumber: string | null): void {
        this.client.nationalInsuranceNumber = nationalInsuranceNumber;
    }
}

